import PageHeaderMeta from '@liveauctioneers/caterwaul-components/lib/PageHeaderMeta/PageHeaderMeta';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { getNotificationsUrl } from '@/utils/urls';

const NotificationsPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'notificationsPage.title' }));
    const description = formatMessage({ id: 'notificationsPage.description' });
    const canonical = `${baseUrl}${getNotificationsUrl()}`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default NotificationsPageHeaderMeta;
